import React from 'react';
import { useData } from '../context/DataContext';

export default function TrustStrip() {
  const { trustStats } = useData();
  if (!trustStats.length) return null;
  return (
    <section className="border-y border-line bg-mist" data-testid="trust-strip">
      <div className="max-w-7xl mx-auto px-5 md:px-8 grid grid-cols-2 lg:grid-cols-4 divide-x divide-line">
        {trustStats.map((s, i) => (
          <div key={i} className={`py-7 md:py-9 ${i % 2 === 0 ? 'pr-6' : 'px-6'} lg:px-8 ${i === 0 ? 'lg:pl-0' : ''}`} data-testid={`trust-stat-${i}`}>
            <div className="font-mono text-2xl md:text-3xl font-bold text-navy tracking-tight">{s.value}</div>
            <div className="mt-1.5 text-xs md:text-sm text-slate-500">{s.label}</div>
          </div>
        ))}
      </div>
    </section>
  );
}
